export default __webpack_public_path__ + "static/media/verifyerror.08547e2f.svg";